import React from 'react';

const joinNames = (names) => {
  if (names.length <= 1) return names[0] || '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

/** Shown when the selected state has no farmers or soil tests for this partner. */
const NoDataStateNotice = ({ stateName, activeStateNames, onReset }) => (
  <section className="csr-card csr-notice" aria-live="polite">
    <span className="csr-chip csr-chip--amber csr-chip--caps">No data yet</span>
    <h2>{`No data for this partner in ${stateName} yet`}</h2>
    <p>
      {activeStateNames.length
        ? `This partner is currently active in ${joinNames(activeStateNames)}. `
        : 'This partner has no farmers or soil tests recorded yet. '}
      {`This view fills in automatically once farmers or soil tests are recorded in ${stateName}.`}
    </p>
    <button type="button" className="csr-btn" onClick={onReset}>Back to All India</button>
  </section>
);

export default NoDataStateNotice;